import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button';
import AppSwitcherIcon from '@atlaskit/icon/glyph/app-switcher';
import EmailIcon from '@atlaskit/icon/glyph/email';
import { MarieSchemaAnalytics } from '@atlassiansox/bxpkit-core';
import styled from '@emotion/styled';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from '../../../../../messages/sign-up-form';
import { UnionIcon } from '../Icons/UnionIcon';

export type CarouselEndProps = {
  readonly isBundleDevops: boolean;
  readonly goToProduct: string;
};

export function CarouselEnd({ isBundleDevops, goToProduct }: CarouselEndProps) {
  const { createAnalyticsEvent } = useAnalyticsEvents();
  const product = isBundleDevops ? 'Jira' : 'Devops';
  const context = useContext(MarieSchemaAnalytics);
  const buttonId = 'go-to-jira-42074419682455333';
  const buttonClick = () => {
    context?.analyticsTrack?.segment(`bxp.formCloudSignup.go-to-jira-button`, {
      eventType: 'track',
      eventContainer: 'carouselEnd',
      event: 'clicked',
      eventComponent: 'button',
      label: `Go to ${product}`,
      uuid: '42074419682455333',
      productKey: context.productKey,
      productsOffered: context.productsOffered,
      loginUserDetected: context.loginUserDetected,
      userEmail: context.userEmail,
      suiteName: context.suiteName,
      productEdition: context.productEdition,
      productPlatform: context.productPlatform,
      schemaVersion: context.schemaVersion
    });
    createAnalyticsEvent({
      eventName: 'bxp.formCloudSignup.go-to-jira-button',
      data: {
        event: 'clicked',
        uuid: '42074419682455333',
        eventType: 'track',
        eventContainer: 'carouselEnd',
        eventComponent: 'button',
        label: `Go to ${product}`,
        productKey: context.productKey,
        productsOffered: context.productsOffered,
        loginUserDetected: context.loginUserDetected,
        userEmail: context.userEmail,
        suiteName: context.suiteName,
        productEdition: context.productEdition,
        productPlatform: context.productPlatform,
        schemaVersion: context.schemaVersion
      }
    }).fire();

    window.location.assign(goToProduct);
  };
  return (
    <div>
      <DevOpsCarouselEndHeading>
        {' '}
        <FormattedMessage {...messages.devopsCarouselEndHeading} />
      </DevOpsCarouselEndHeading>
      <DevopsCarouselEndGroup>
        <EmailIcon label="Email Icon" />
        <DevopsCarouselEndText>
          <FormattedMessage {...messages.devopsCarouselEndTextOne} />
        </DevopsCarouselEndText>
      </DevopsCarouselEndGroup>
      <DevopsCarouselEndGroup>
        <AppSwitcherIcon size="medium" label="appswitcherIcon" />
        <DevopsCarouselEndText>
          <FormattedMessage {...messages.devopsCarouselEndTextTwo} />
        </DevopsCarouselEndText>
      </DevopsCarouselEndGroup>
      <DevopsCarouselEndGroup>
        <UnionIcon />
        <DevopsCarouselEndText>
          <FormattedMessage {...messages.devopsCarouselEndTextThree} />
        </DevopsCarouselEndText>
      </DevopsCarouselEndGroup>
      <DevOpsCarouselEndButton>
        <Button appearance="primary" id={buttonId} onClick={buttonClick}>
          <FormattedMessage
            {...messages.devopsCarouselButton}
            values={{ product }}
          />
        </Button>
      </DevOpsCarouselEndButton>
    </div>
  );
}
const DevopsCarouselEndGroup = styled.div`
  display: flex;
  margin: 0 auto 20px auto;
  max-width: 280px;
`;
const DevopsCarouselEndText = styled.div`
  font-size: 14px;
  line-height: 20px;
  margin-left: 15px;
  font-family: Charlie Display, -apple-system, BlinkMacSystemFont, Segoe UI,
    Roboto, Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif;
  font-style: normal;
`;
const DevOpsCarouselEndHeading = styled.div`
  font-family: Charlie Display;
  font-size: 32px;
  line-height: 30px;
  text-align: center;
  margin-bottom: 60px;
`;
const DevOpsCarouselEndButton = styled.div`
  text-align: center;
  margin-top: 70px;
`;
